module.exports = __webpack_public_path__ + "static/media/inventory-create-icon.bb7d1df1.svg";